import { IHttpRepository } from "Infrastructure/interfaces/IHttpRepository";
import { HttpRepository } from "Infrastructure/repositories/api/_HttpRepository";
import { IDiscountsService } from "modules/order/application/interfaces/IDiscountsService";
import { IDiscounts } from "modules/order/domain/models/IDiscounts";

export const DiscountsService = (): IDiscountsService => {
  const httpRepository: IHttpRepository = HttpRepository();

  const getUserDiscounts = async (
    cpf: string,
    eventId: string
  ): Promise<IDiscounts[] | null> => {
    const response = await httpRepository.getAsync<IDiscounts[]>(
      `/SuperApp/Event/Events/${eventId}/Discounts/ByDocument/${cpf}`
    );
    return response;
  };

  return { getUserDiscounts };
};
